<template>
  <div>
    <div class="card shadow">
      <div class="card-header bg-transparent">
        <div>
          <template>
            <div class="col-sm-3">
               <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a>
                    <!-- <button 
                        type="button"    
                        @click="hasHistory() 
                            ? $router.go(-1) 
                            : $router.push('/')" class="btn btn-secondary">&laquo; 
                            {{$t('message.backtap')}}
                    </button> -->
                    </div>
            <h3 class="mb-0">Paiement d'affiliation</h3>
            
          </template>
        </div>
      </div>

      <div class="">
        <div
          class="container"
          v-if="
            mContract.statut_paiement != 'PAYÉ' &&
            mContract.statut_paiement != 'PAYE'
          "
        >
          <b-container class="text-center">
            <p>Nos offres</p>
            <!-- <b-form-radio label="Mobile money" :value="value" > {{value.description_fr}}</b-form-radio> -->
            <b-tabs content-class="mt-3" v-if="!mobileView">
              <div class="row" v-for="(value, key) in offres" :key="key">
                <b-tab :title="value.description_fr" class="table-responsive">
                  <table class="table table-bordered table-hover" style="width:100%">
                    <thead class="">
                      <tr class="">
                        <th>Services</th>
                        <th v-for="(val, index) in value.packages" :key="index">
                          {{ val.description_fr }}
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      class=""
                      v-for="(item, index) in value.items" :key="index">
                      <tr>
                        <td class="text-left">
                          <span>{{ item.fr_description }}</span>
                        </td>
                        <td v-for="(v, index) in item.packages" :key="index">
                          <span>{{ v.value }}</span>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot class="">
                      <tr class="">
                        <td></td>
                        <td v-for="(val, index) in value.packages" :key="index">
                          <div>{{ val.montant }} EUROS</div>
                          <b-btn
                            variant="primary"
                            :loading="loader"
                            color="primary"
                            @click="wanToPaid(val)"
                          >
                            Souscrire
                          </b-btn>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </b-tab>
              </div>
            </b-tabs>
          </b-container>
          <div class="content__trajet" v-if="mobileView">
            <div class="px-md-6 py-4 content__scroll">
              <div class="trajet__box" v-for="(value, key) in offres" :key="key"> <!-- v-for="(ligne_temp, index) in filterTrajet" :key="index" @click="changeColor(index)" v-model="motif" -->
                  <div v-b-toggle="'collapse'+key" class="trajet__info mt-2 px-2 px-md-4 d-flex justify-content-between align-items-center trajet__active"> <!-- ="'collapse'+index" :class="{ 'trajet__active' : selectTrajet }"-->
                      <div class="trajet__info--text d-flex align-items-center fs-6">
                          <!-- <i class="fa fa-calendar text-primary" aria-hidden="true"></i> -->
                          <!-- <span class="px-2 d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span> -->
                          <span class="text-default">{{ value.description_fr }} </span>
                      </div>
                  </div>
                  <b-collapse :id="'collapse'+key"  class="mt-1">
                      <div>
                          <div class="py-2">
                            <div class="" v-for="(val, index) in value.packages" :key="index"> <!-- v-for="(validation, index_val) in validation_financiere_ligne_temps" :key="'validation_financiere_ligne_temp'+index_val"-->
                              <div class="list-group-item">
                                <p class="ligne">
                                  <span class="font-weight-bold new-title mr-4">
                                  {{ val.description_fr }}
                                  </span>
                                </p>
                              </div>  
                              <div>
                                <div class="list-group-item " v-for="(item, index) in value.items" :key="index">
                                  <div>
                                  <p class="ligne">
                                    <span class="mr-2 new-title">{{ truncate(item.fr_description,20) }}</span><br>
                                    <span>
                                      <span v-for="(val, index) in value.packages" :key="index">
                                        <td>{{ truncate(val.description_fr,20) }}</td>
                                        <!-- mb_strimwidth($string, 0, 97, '...') -->
                                        <!-- <td class="text-rigt" v-for="(v, index) in item.packages" :key="index">{{v.value }}</td> -->
                                      </span>
                                      
                                    </span>
                                    <!-- <span class="font-weight-bold text-gray" > {{v.value }} </span> -->
                                  </p>
                                  </div>
                                  <div class="text-right new_element">
                                    <ul>
                                      <li v-for="(v, index) in item.packages" :key="index">{{v.value }}</li>
                                    </ul>
                                  </div>
                                </div>
                                
                                  <!-- <div class="ligne text-gray">
                                    <div class="list-group-item">
                                      <p class="" v-for="(val, index) in value.packages" :key="index">{{ val.description_fr }}</p>:
                                      <span>Value</span>
                                    </div>
                                  </div> -->
                                  <!-- <p> v-for="(v, index) in item.packages" :key="index" -->
                                    <!-- <span class="ligne med_bilan" style="position: relative; bottom: 100px; right: 10px">{{ v.value }}</span><br> -->
                                  <!-- </p> -->
                                  <b-col class="card-footer mt-2 mb-2 ">
                                  <b-btn style="width: 100%"
                                    variant="primary"
                                    :loading="loader"
                                    color="primary"
                                    @click="wanToPaid(val)"
                                  >
                                    Souscrire
                                  </b-btn>
                                  </b-col>
                              </div>
                              <!-- {{item}}  -->
                              
                            </div>
                          </div>
                      </div>
                  </b-collapse>

                  <div>
                    <b-modal id="modal-1" title="BootstrapVue">
                      <p class="my-4">Hello from modal!</p>
                      <div>
                          <h3 class="text-center text-success mt-5">Total validé</h3> <!-- {{ total_validation_financiere.total_souscripteur }} -->
                      </div>
                    </b-modal>
                  </div>
              </div>
            </div>
          </div>
          
        </div>
        <b-container class="text-center" v-else>
          <p>{{$t('message.dejapaye')}}</p>
          <p>Merci d'avoir choisi Medicasure</p>
        </b-container>
      </div>

      <b-modal
        ref="my-modal"
        :title="selectedPackage.description_fr"
        size="lg"
        header-bg-variant="success"
        header-text="light"
        hide-footer
      
      >
        <b-container class="text-center mb-3">
          <p>{{$t('message.moyenpaiement')}} :</p>
          <b-form-radio-group
            v-model="moyenPaiement"
            text-align="center"
            class="justify-center"
          >
            <!-- <b-form-radio label="Mobile money" value="mtn"
              >Mobile money</b-form-radio
            > -->

            <b-form-radio label="Orange money" value="orange"
              >Orange money</b-form-radio
            >

            <!-- <b-form-radio label="UBA" value="uba">UBA</b-form-radio> -->

            <b-form-radio label="Carte de crédit" value="stripe"
              >{{$t('message.creditcard')}}</b-form-radio
            >
          </b-form-radio-group>
        </b-container>
        <div class="row">
          <div class="" v-if="moyenPaiement == 'mtn'">
            <b-container wrap>
              <b-card class="mx-auto" outlined>
                <b-container class="">
                  <div class="row">
                    <!-- <div class="col-sm-5"></div> -->
                    <div class="col-sm-2">
                      <b-img
                        align-center
                        style="margin: 0 auto"
                        height="50%"
                        src="/img/momo.jpg"
                      >
                      </b-img>
                    </div>
                    <!-- <div class="col-sm-5"></div> -->
                  </div>
                </b-container>
                <b-form ref="mtn">
                  <b-container fluid grid-list-x1>
                    <b-container wrap align-center>
                      <b-col xs='12' d-col>
                        <b-form-group
                          id="lastName-group"
                          :label="$t('message.referenceDuPaiement')"
                          label-for="referenceDuPaiement"
                        >
                          <b-form-input
                            v-model="mContract.externalId"
                            color="primary"
                            :rules="[nameRules.required]"
                            :label="$t('message.referenceDuPaiement')"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col xs12 d-col>
                        <b-form-group
                          id="lastName-group"
                          :label="$t('message.phone1Souscripteur')"
                          label-for="phone1Souscripteur"
                        >
                          <b-form-input
                            v-model="numeroTelephoneMtn"
                            :rules="[
                              phoneRules.required,
                              phoneRules.numeric,
                              phoneRules.min,
                              phoneRules.mtn,
                            ]"
                            color="primary"
                            :label="$t('message.phone1Souscripteur')"
                            prefix="00237"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col xs12 d-col>
                        <b-form-group>
                          <b-input-group
                            id="quantite-group"
                            :label="$t('message.quantite')"
                            label-for="quantite"
                          >
                            <b-form-input
                              type="number"
                              v-model="quantite"
                              min="1"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                      <b-col xs='12' d-col>
                        <b-form-group>
                          <b-input-group
                            id="montant-group"
                            :label="$t('message.montantSouscription')"
                            label-for="montantSouscription"
                            append="EUR"
                          >
                            <b-form-input
                              v-model="prixFinal"
                              readonly
                              color="primary"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-container>
                  </b-container>
                </b-form>
                <p v-if="isLoading">{{$t('message.isloading')}}</p>
                <div class="d-flex justify-content-center" v-if="isLoading">
                    <div class="loading"></div>
                </div>
                <b-container class="align-center" v-else>
                  <div class="row">
                    <!-- <div class="col-sm-5"></div> -->
                    <div class="col-sm-12 d-flex justify-content-center">
                      <b-btn
                        variant="primary"
                        :loading="loader"
                        color="primary"
                        @click="submit"
                      >
                        {{ $t("message.Paie") }}
                      </b-btn>
                    </div>
                    <!-- <div class="col-sm-5"></div> -->
                  </div>
                </b-container>
              </b-card>
            </b-container>
          </div>
        </div>
        <div class="row">
          <div class="col" v-if="moyenPaiement == 'stripe'">
            <b-form ref="stripe">
                <b-container fluid grid-list-x1>
                  <b-container wrap>
                    <b-col xs12 d-col>
                      <b-form-group>
                        <b-input-group
                          id="quantite-group"
                          :label="$t('message.quantite')"
                          label-for="quantite"
                        >
                          <b-form-input
                            type="number"
                            v-model="quantite"
                            min="1"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col xs12 d-col>
                      <b-form-group>
                        <b-input-group
                          id="montant-group"
                          :label="$t('message.montantSouscription')"
                          label-for="montantSouscription"
                          append="EUR"
                        >
                          <b-form-input
                            v-model="prixFinal"
                            readonly
                            color="primary"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-container>
                </b-container>
                <p v-if="isLoading">{{$t('message.isloading')}}</p>
                <div class="d-flex justify-content-center" v-if="isLoading">
                    <div class="loading"></div>
                </div>
                <b-container class="align-center" v-else>
                  <div class="row">
                    <!-- <div class="col-sm-5"></div> -->
                    <div class="col-sm-12 d-flex justify-content-center">
                      <b-btn
                        variant="primary"
                        :loading="loader"
                        color="primary"
                        @click="goToStripe"
                      >
                        {{ $t("message.Paie") }}
                      </b-btn>
                    </div>
                    <!-- <div class="col-sm-5"></div> -->
                  </div>
                </b-container>
            </b-form>
          </div>
        </div>
        <div class="row">
          <div class="col" v-if="moyenPaiement == 'orange'">
            <b-card>
              <!-- <div class="">
                  <div class="col-sm-5">
                    <b-img
                      align-center
                      class=""
                      height="50%"
                      src="/img/orange.png"
                    ></b-img>
                  </div>
              </div> -->
              <div class="row justify-content-md-center mb-3">
                <!-- <div class="col col-lg-2">
                  1 of 3
                </div> -->
                <div class="col-md-auto">
                  <b-img align-center class="" height="70%" src="/img/orange.png"> </b-img>
                </div>
                <!-- <div class="col col-lg-2">
                  3 of 3
                </div> -->
              </div>
              <b-form ref="orange">
                    <b-col>
                      <b-form-group
                        id="lastName-group"
                        :label="$t('message.referenceDuPaiement')"
                        label-for="referenceDuPaiement"
                      >
                        <b-form-input
                          v-model="mContract.externalId"
                          color="primary"
                          :rules="[nameRules.required]"
                          disabled
                          :label="$t('message.referenceDuPaiement')"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col>
                      <b-form-group
                        id="lastName-group"
                        :label="$t('message.phone1Souscripteur')"
                        label-for="phone1Souscripteur"
                      >
                        <b-form-input
                          v-model="numeroTelephoneOrange"
                          :rules="[
                            phoneRules.required,
                            phoneRules.numeric,
                            phoneRules.min,
                            phoneRules.orange,
                          ]"
                          color="primary"
                          :label="$t('message.phone1Souscripteur')"
                          prefix="00237"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group>
                        <b-input-group
                          id="quantite-group"
                          :label="$t('message.quantite')"
                          label-for="quantite"
                        >
                          <b-form-input
                            type="number"
                            v-model="quantite"
                            min="1"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group>
                        <b-input-group
                          id="montant-group"
                          :label="$t('message.montantSouscription')"
                          label-for="montantSouscription"
                          append="EUR"
                        >
                          <b-form-input
                            v-model="prixFinal"
                            readonly
                            color="primary"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                <p v-if="isLoading">{{$t('message.isloading')}}</p>
                <div class="d-flex justify-content-center" v-if="isLoading">
                    <div class="loading"></div>
                </div>
                <!-- <b-container class="align-center" v-else>
                  <div class="row">
                    <div class=""></div>
                    <div class="">
                      <b-btn
                        variant="primary"
                        :loading="loader"
                        color="primary"
                        @click="omsubmit"
                      >
                        {{ $t("message.Paie") }}
                      </b-btn>
                    </div>
                  </div>
                </b-container> -->
                <div class="row justify-content-md-center mb-3" v-else>
                  <div class="col-md-auto">
                    <b-btn variant="primary" :loading="loader" color="primary" @click="omsubmit">
                      {{ $t("message.Paie") }}
                    </b-btn>
                  </div>
                </div>
              </b-form>
            </b-card>
          </div>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
window.$ = window.jQuery = window.jquery = require("jquery");
import Vue from "vue";
import { mapGetters } from "vuex";
import _ from "lodash";
import moment from "moment";
import AppConfig from "../../constants/AppConfig";
import Swal from "sweetalert2";
export default {
  name: "Paiement",
  components: {
  },
  computed: {
    ...mapGetters(["guestContract", "patient", "suscribe", "loader"]),

    types: function () {
      let types = ["Annuelle"];
      if (moment().isBefore("2020-09-07")) {
        types.push("One shot");
      }
      //this.getPrix();
      return types;
    },

    mContract: function () {
      let contract = this.patient;
      let souscripteur = JSON.parse(localStorage.getItem("user"));
      //let communication = (JSON.parse(localStorage.getItem('user')))['pays'] == 'Cameroon' ? 'CIMCAM' : 'CIM';
      let nomComplet = souscripteur["nom"] + " " + souscripteur["prenom"];
      let type =
        this.selectedPackage == "" ? "" : this.selectedPackage.description_fr;
      let externalId = nomComplet + "-" + type;
      contract["externalId"] = externalId;
      this.numeroTelephoneOrange = JSON.parse(localStorage.getItem("user"))[
        "telephone"
      ];
      this.numeroTelephoneMtn = JSON.parse(localStorage.getItem("user"))[
        "telephone"
      ];

      return contract;
    },
  },

  watch: {
    moyenPaiement: function (val) {
      if (val == "stripe") {
        // console.log("stripe");

        //this.goToStripe();
      }
    },
    code: function (val) {
      this.getCode();
      // this.getPrix();
    },
    quantite: function (val) {
      this.prixFinal = val * this.prixInitial;
    },
  },

  data() {
    return {
      mobileView: true,
      ubaUrl:
        AppConfig.paymentUrl +
        "/api/v1.0.0/uba-paiement/" +
        this.$route.params.identifiant,
      moyenPaiement: "",
      quantite: 1,
      prixInitial:0,
      isLoading: false,
      opacity: 0.5,
      canCancel: false,
      fullPage: true,
      selectedPackage: "",
      offre_affiliation: "Annuelle",
      identifiant: this.$route.params.identifiant,
      montant: "",
      offres: [],
      package: null,
      numeroTelephoneOrange: "",
      numeroTelephoneMtn: "",
      form: {
        referenceId: "",
        externalId: "",
        numeroTelephone: "",
      },
      code: "",
      nameRules: {
        required: (value) => !!value || this.$i18n.t("message.requiredField"),
        min: (v) =>
          v.length >= 9 ||
          this.$i18n.t("message.minCharacters", {
            n: 9,
          }),
      },
      phoneRules: {
        required: (value) => !!value || this.$i18n.t("message.requiredField"),
        min: (v) =>
          v
            ? v.length == 9 ||
              this.$i18n.t("message.nCharacters", {
                n: 9,
              })
            : true,
        numeric: (v) =>
          v ? /^[0-9]+$/gi.test(v) || this.$i18n.t("message.numeric") : true,
        orange: (v) =>
          v
            ? /^6(9[0-9]{7})|(5[5-9]{1}[0-9]{6})$/gi.test(v) ||
              this.$i18n.t("message.orange")
            : true,
        mtn: (v) =>
          v
            ? /^6((7|8)[0-9]{7})|(5[0-4]{1}[0-9]{6})$/gi.test(v) ||
              this.$i18n.t("message.mtn")
            : true,
      },
      patient_slug: this.$route.params.identifiant,
    };
  },

  methods: {
    handleView() {
        this.mobileView = window.innerWidth <= 990;
    },
    truncate(str, n){
      return (str.length > n) ? str.slice(0, n-1) + '...' : str;
    },
    hasHistory () { return window.history.length > 2 },
    goToStripe() {
      // var stripe = Stripe(
      //   "pk_live_51Hf6FLJRvANUAsFaJCdg8V6CkkhClwXTZDGKqk7AsNUgOfIxGHyRkv2t1bnIfS61iTjIP2OIZk18W99hA0sJcCVh00R9zr6xr7"
      // );
       this.isLoading= true;
       var stripe = Stripe(AppConfig.stripe_key);
       const localToken = localStorage.getItem('ms-token');
       fetch(AppConfig.apiUrl + "/paiement/stripe-paiement", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
          "Authorization": "Bearer " + localToken
        },
        body: JSON.stringify({
          identifiant: this.$route.params.identifiant,
          amount: this.prixFinal,
          package_id: this.selectedPackage.id,
          quantite: this.quantite,
          souscripteur_id: JSON.parse(localStorage.getItem("user")).id
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (session) {
          return stripe.redirectToCheckout({
            sessionId: session.id,
          });
        })
        .then(function (result) {
          // If `redirectToCheckout` fails due to a browser or network
          // error, you should display the localized error message to your
          // customer using `error.message`.
          if (result.error) {
            alert(result.error.message);
          }
        })
        .catch(function (error) {
          // console.error('Error:', error);
        });
    },

    getPatient() {
      let args = {
        patient: this.patient_slug,
      };

      this.$store.dispatch("getPatient", {
        args,
      });
    },
    submit() {
      this.isLoading = true;
      let args = {
        externalId: this.mContract.externalId,
        phone: this.numeroTelephoneMtn,
        referenceId: JSON.parse(localStorage.getItem("user"))["slug"],
        identifiant: JSON.parse(localStorage.getItem("user"))["slug"], //this.identifiant,
        amount: 100,
        message: "Medicasure",
        note: "paiement affiliation", //this.mContract.montantSouscription
      };
      fetch(AppConfig.apiUrl + "/paiement/momo/paid", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify(args),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (result) {
          if (result.status == "SUCCESSFULL") {
            let param = {
              identifiant: JSON.parse(localStorage.getItem("user"))["slug"],
              reference: result.reponse.reference,
            };
            this.$router.push({
              name: "momo-notification",
              params: param,
            });
          }
          if (result.status == "FAILED") {
            Swal.fire(
              "OUPS!",
              "Le paiement n'a pas abouti, veuillez réessayer plus tard",
              "warning"
            );
          }
          this.isLoading = false;
        })

        .catch(function (error) {
          this.isLoading = false;
          console.error("Error:", error);
        });
    },

    ubaSubmit() {
      nativeForm.submit();
    },

    backAddAffiliation() {
      this.$router.push({
        name: "add-affiliation",
      });
    },
    getOffres() {
      let self = this;
      fetch(AppConfig.apiUrl + "/offres", {
        method: "GET",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (result) {
          self.offres = result.offres;
        })
        .catch(function (error) {
          console.error("Error:", error);
        });
    },
    wanToPaid(val) {
      this.$refs["my-modal"].show();
      this.prixFinal = val.montant;
      this.prixInitial = val.montant;
      this.selectedPackage = val;
    },
    omsubmit() {
      this.isLoading = true;
      let args = {
        externalId: this.mContract.externalId,
        subscriberMsisdn: this.numeroTelephoneOrange,
        referenceId: JSON.parse(localStorage.getItem("user"))["slug"],
        identifiant: this.$route.params.identifiant, //this.identifiant,
        amount: this.prixFinal,
        quantite: this.quantite,
        package_id: this.selectedPackage.id,
        description: "Medicasure: paiement de l'affiliation "+this.selectedPackage.description_fr, //this.mContract.montantSouscription
      };
      let self = this;
      // AppConfig.paymentUrl+'/api/v1.0.0/om/paid'
      fetch(AppConfig.apiUrl + "/paiement/om/paid", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify(args),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (result) {
          if(result.reponse == undefined){
            Swal.fire(
                'ERREUR',
                "Le numéro que vous avez renseigné n'est pas correct. <br/><br/> Le format est le <b>6xxxxxxxx</b>",
                'error'
            )
          }
          else if (result.reponse.message !=undefined &&  result.reponse.message.includes('successfully')) {
            let param = {
              identifiant: JSON.parse(localStorage.getItem("user"))["slug"],
              pay_token: result.reponse.data.payToken,
            };
            self.$router.push({
              name: "om-notification",
              params: param,
            });
          }
          else {
            if (result.reponse.original!= undefined && result.reponse.original.erreur.includes('Le solde du compte du payeur est insuffisant')) {
              Swal.fire(
                "Echec de Paiement!",
                "Le solde du compte du payeur est insuffisant",
                "error"
              );
            }else if (result.reponse.original!= undefined && result.reponse.original.erreur.includes('Beneficiaire introuvable')) {
              Swal.fire(
                "Echec de Paiement!",
                "Le numéro que vous avez renseigné n'a pas de compte Orange Money. <br/><br/> Veuillez vérifier et reéssayer",
                "error"
              );
            }else{
                   Swal.fire(
                       'ERREUR',
                       'Veuillez réessayer plus tard ',
                       'error'
                   )
               }
          }
          self.isLoading = false;
        })
        .catch(function (error) {
          Swal.fire(
            'ERREUR',
            'Veuillez réessayer plus tard ',
            'error'
          )
          self.isLoading = false;
        });
    },

    getUUID() {
      let self = this;
      $.ajax({
        url: "https://www.uuidgenerator.net/api/version4",
        type: "GET",
        // Request body
        data: "{body}",
      })
        .done(function (data) {
          // console.log(data);
          self.form.referenceId = data;
        })
        .fail(function () {});
    },
    getCode() {
      let self = this;
      $.ajax({
        url: AppConfig.paymentUrl + "api/v1.0.0/code-promo",
        type: "GET",
      })
        .done(function (data) {
          for (var i = 0; i < data.codes.length; i++) {
            if (data.codes[i].code === self.code) {
              // alert();
              self.prixFinal = self.newPrix(data.codes[i]);
            }
          }
        })
        .fail(function () {});
    },
  },
  created() {
    this.handleView();
    window.addEventListener('resize', this.handleView);
  },
  mounted() {
    let ckeditor = document.createElement("script");
    ckeditor.setAttribute("src", "https://js.stripe.com/v3/");
    document.head.appendChild(ckeditor);

    //this.getContract();
    this.getOffres();
    this.getUUID();


    //this.getPatient();
  },
};
</script>

<style>
#modal-scoped___BV_modal_backdrop_ {
  display: none !important;
}
.modal-backdrop {
  display: none !important;
}
</style>